import React from 'react';
import './HomePage.css';
import Gauge from '../components/Gauge';
import { menuData } from '../data/menuData';
import PillarCard from '../components/PillarCard';

const HomePage = () => {
    return (
        <div>
            {/* The header has been moved to MainLayout.js */}

            {/* <div className="dashboard-controls">
                <div className="search-bar">
                    <i className="fas fa-search"></i>
                </div>
                <div className="date-picker">
                    <i className="fas fa-calendar-alt"></i>
                    <span>Oct 6, 2025 - Oct 6, 2025</span>
                </div>
                <div className="dropdown">
                    <span>Demo</span>
                    <i className="fas fa-chevron-down"></i>
                </div>
            </div> */}

            <div className="dashboard-grid">
                <h2 className="grid-title">Automation Impact Insights</h2>
                <div className="stat-grid">
                    <div className="widget stat-widget">
                        <p className="stat-title">Agentic Agent Coverage <span className="stat-percent">(48.25%)</span></p>
                        <p className="stat-value">48.25 <span className="stat-unit">%</span></p>
                        <div className="stat-mini-bar-container"><div className="stat-mini-bar blue" style={{width: '48%'}}></div></div>
                        <div className="stat-bar-container"><div className="stat-bar blue" style={{width: '48%'}}></div></div>
                        <div className="coverage-table-container">
                            <table className="coverage-table">
                                <thead>
                                    <tr>
                                        <th>L1</th>
                                        <th>L2</th>
                                        <th>L3</th>
                                        <th>L4</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div className="coverage-val">88%</div>
                                            <div className="coverage-sub">5% MoM</div>
                                        </td>
                                        <td>
                                            <div className="coverage-val">60%</div>
                                            <div className="coverage-sub">12% MoM</div>
                                        </td>
                                        <td>
                                            <div className="coverage-val">30%</div>
                                            <div className="coverage-sub">8% MoM</div>
                                        </td>
                                        <td>
                                            <div className="coverage-val">15%</div>
                                            <div className="coverage-sub">4% MoM</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="widget stat-widget">
                        <p className="stat-title">Ticket Deflection Rate <span className="stat-percent">(34.5%)</span></p>
                        <p className="stat-value">34.5 <span className="stat-unit">%</span></p>
                        <div className="stat-mini-bar-container"><div className="stat-mini-bar green" style={{width: '34%'}}></div></div>
                        <div className="stat-bar-container"><div className="stat-bar green" style={{width: '34%'}}></div></div>
                        <div className="coverage-table-container">
                            <table className="coverage-table">
                                <thead>
                                    <tr>
                                        <th>L1</th>
                                        <th>L2</th>
                                        <th>L3</th>
                                        <th>L4</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div className="coverage-val">68%</div>
                                            <div className="coverage-sub"> </div>
                                        </td>
                                        <td>
                                            <div className="coverage-val">42%</div>
                                            <div className="coverage-sub"> </div>
                                        </td>
                                        <td>
                                            <div className="coverage-val">18%</div>
                                            <div className="coverage-sub"> </div>
                                        </td>
                                        <td>
                                            <div className="coverage-val">10%</div>
                                            <div className="coverage-sub"> </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>



            </div>
            <div className="pillars-section">
                <h2 className="pillars-section-title">Explore the 10 Foundational Domains</h2>
                <div className="pillar-card-grid">
                    {menuData.map(pillar => {
                        // The PillarCard component now automatically uses the 'live: true'
                        // flag from your menuData to apply the green styling.
                        return (
                            <PillarCard
                                key={pillar.title}
                                pillar={pillar}
                            />
                        );
                    })}
                </div>
            </div>
            <div className="kpi-section">
                <h2 className="kpi-section-title">Overall System Performance</h2>
                <div className="gauge-grid">
                    <Gauge label="Agent Accuracy" value="98.5" unit="%" target="> 98.0% Target" />
                    <Gauge label="Agent Uptime" value="100" unit="%" target="100% SLA" />
                    <Gauge label="Deployed Agents" value="350" unit="+" target="Total Agents" />
                    <Gauge label="Vendor APIs" value="120" unit="+" target="Integrations" />
                    <Gauge label="CSAT" value="4.9" unit="/5.0" target="High Satisfaction" color="#10b981" />
                    <Gauge label="NPIs" value="67" unit="+" target="New Platform Integrations" color="#10b981" />
                    <Gauge label="Tickets Prevented" value="3452" unit="" target="(L1 72%)" />
                    <Gauge label="Agent-to-Engineer" value="6.5" unit=":1" target="Efficiency Ratio" />
                    <Gauge label="Cost per Ticket" value="6" unit="$" target="Reduced from $19" color="#10b981" />
                    <Gauge label="Cost Avoidance" value="1.8" unit="M$" target="Year-to-Date" color="#10b981" />
                    <Gauge label="False + Rate" value="1.5" unit="%" target="Error Rate" color="#10b981" />
                    <Gauge label="Agent Learning Velocity" value="8" unit="%" target="Month-over-Month" />
                </div>
            </div>

            <div className="widget widget-full">
                <h3><i className="fas fa-check-circle icon-green"></i> Key Automation Achievements</h3>
                <ul>
                    <li><b>Proactive Engineering:</b> Successfully replaced reactive IT with proactive, outcome-driven operations.</li>
                    <li><b>Incident Preemption:</b> Agentic Agents are preempting incidents and automating complex workflows.</li>
                    <li><b>High-Value Focus:</b> Human teams are freed to focus on higher-value engineering and innovation.</li>
                    <li><b>Integrated Operations:</b> Full-spectrum coverage across cloud, cybersecurity, networks, and applications.</li>
                </ul>
            </div>

            <div className="widget widget-full">
                <h3><i className="fas fa-lightbulb icon-yellow"></i> Opportunities for Expansion</h3>
                <div className="maturity-score">Overall Automation Maturity: <b>HIGH</b></div>
                <ul>
                    <li><b>Use Case Discovery:</b> Identify highest-value automation opportunities in new business units.</li>
                    <li><b>Backlog Curation:</b> Build a roadmap of new agentic agents aligned to key client priorities and ROI.</li>
                    <li><b>Continuous Learning:</b> Fine-tune agents based on telemetry and error recovery patterns to boost efficiency.</li>
                </ul>
            </div>

        </div>
    );
};

export default HomePage;
